// @ts-nocheck
export default {
  setAppReady ({ commit }, val) {
    commit('SET_APP_READY', val)
  },
  setNotificationsPoolingInterval ({ commit }, interval) {
    commit('SET_NOTIFICATIONS_POOLING_INTERVAL', interval)
  }
}
